export const experiences = [
  {
    id: 1,
    title: "Aug 2025 — Present",
    role: "Frontend Developer",
    company: "SimpleWay for Digital Solutions",
    type: "Full-time",
    location: "Egypt",
    skills: [
      "React.js",
      "Next.js",
      "ASP.NET Core",
      "Dashboards",
      "CI/CD",
      "Git",
    ],
    points: [
      "Contributed to building a GRC (Governance, Risk & Compliance) system for managing organizational risk and compliance workflows.",
      "Developed and maintained web applications using React.js, Next.js, and ASP.NET Core APIs.",
      "Built dashboards and data-driven UI components for risk tracking and reporting, integrating complex APIs with dynamic visualizations.",
      "Implemented reusable components and optimized UI performance, improving render efficiency across multiple modules.",
      "Participated in code reviews, debugging sessions, and API integration to keep the codebase maintainable.",
      "Worked with CI/CD pipelines, Git, and Agile workflows in a production team.",
    ],
  },
  {
    id: 2,
    title: "2025 — 2026",
    role: "Freelance Frontend Developer",
    company: "SECURESIST — Cybersecurity Awareness Platform",
    type: "Freelance",
    location: "Remote",
    site: "https://securesist.com",
    skills: [
      "React",
      "Vite",
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "React Query",
      "next-intl",
    ],
    points: [
      "Delivered the full frontend for a production cybersecurity SaaS platform used by organizations to train employees and simulate cyber threats.",
      "Built a responsive dashboard with React, Vite, Tailwind CSS, React Router, React Query, and Axios — covering role-based interfaces for business owners, vendors, sales/admin, and employees.",
      "Developed modules for cybersecurity training, video learning, quizzes, certificates, scheduling, chat, user management, and analytics.",
      "Created a multilingual marketing website with Next.js, TypeScript, Tailwind CSS, and next-intl — including home, about, solutions, partners, blog, and contact.",
      "Shipped reusable UI: data tables, charts, calendars, notification systems, and responsive form layouts.",
    ],
  },
  {
    id: 3,
    title: "Feb 2025 — Jun 2025",
    role: "Frontend Developer Trainee",
    company: "Job Simulation Program (JSP) — Upskilling",
    type: "Bootcamp",
    location: "Remote",
    skills: ["React", "TypeScript", "Agile", "GitHub", "Jira", "Auth"],
    points: [
      "Led development of 4+ web applications in a real-world simulation: Quiz App, Trello Clone, Food Management System, and Hotel Booking System.",
      "Applied Agile methodologies including daily stand-ups, sprint planning, demos, and retrospectives.",
      "Collaborated in teams of 3–4 using GitHub for version control and Jira/Trello for task management.",
      "Implemented authentication flows and integrated third-party services.",
    ],
  },
  {
    id: 4,
    title: "Apr 2023 — May 2025",
    role: "Frontend Instructor",
    company: "Google Developer Student Club (GDSC)",
    type: "Mentorship",
    location: "Campus",
    skills: ["HTML", "CSS", "JavaScript", "React", "Workshops"],
    points: [
      "Mentored 150+ students through structured workshops, helping them complete their first frontend projects.",
      "Designed and delivered sessions covering HTML, CSS, JavaScript, and React fundamentals.",
    ],
  },
];
